import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { H6, Spinner, Text, useLocalizeMessage } from 'libs.nucleus';
import { EligibilityCheckStatus } from './eligibility_check_status.component';
import { EligibleLocales } from './eligible_locales.component';
import { useActivitySourceStatus } from '../../hooks';
import { useImportState } from './contexts/import_state.context';
import { useCloneCheckApi } from './hooks/use_clone_check_api';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const WithCloneVersionActivity = ({ activity }) => {
    // Need to call api to check if clone can be done or not
    // Based on the response, show the appropriate message
    const t = useLocalizeMessage();
    const { id: activityId } = useParams();
    const { setCloneCheckStatus, targetLocalizationId, sourceLocalizationId } = useImportState();
    const { sourceActivityName, sourceActivityVersion, sourceLink } = useActivitySourceStatus(activityId);
    const { data, isLoading } = useCloneCheckApi(sourceLocalizationId, targetLocalizationId);
    useEffect(() => {
        setCloneCheckStatus(data?.data.status);
    }, [data?.data.status, setCloneCheckStatus]);
    return (_jsxs("div", { className: 'flex flex-col gap-6', children: [_jsxs("header", { children: [_jsx(H6, { children: t('Translation selection') }), _jsx(Text, { as: 'span', size: 'sm', className: 'text-text-secondary', children: t('Select which locales and which version of the translations to copy over.') })] }), isLoading ? (_jsx(Spinner, { wrapper: 'full' })) : (_jsx(EligibilityCheckStatus, { status: data?.data.status, sourceActivityName: sourceActivityName, sourceActivityVersion: sourceActivityVersion, sourceLink: sourceLink })), sourceLocalizationId && data?.data.status && _jsx(EligibleLocales, { sourceLocalizationId: sourceLocalizationId })] }));
};
